/**
 * Zzzing Guest API
 * Zzzing Guest API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: ci@zzzing.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Define a tour pricing entry
 */
export interface TourPricing { 
    rate_id?: string;
    pricing_category_id?: string;
    title?: string;
    pricing_category?: string;
    min_age?: number;
    max_age?: number;
    price?: number;
}

